import { Chip } from "@mui/material";

const getStatusText = (status) => {
  switch (status) {
    case "pending":
      return "Hochgeladen";
    case "imported":
      return "Importiert";
    case "assigned":
      return "Zugeordnet";
    case "failed":
      return "Fehlgeschlagen";
    default:
      return "Unbekannt";
  }
};

export default function PaymentImportStatusBadge({ status, size = "small" }) {
  const variant = `payment-import_${status || "pending"}`;

  return (
    <Chip
      label={getStatusText(status)}
      variant={variant}
      size={size}
    />
  );
}
